import { useAPISettings } from "@src/data-hooks/general-settings/settings.service";
import { getSingularRoleTitle } from "@src/utils/data/roles.utils";
import { Role } from "../../../to-be-removed/LocalData/User/Role";
import { SelectInputData, SelectInputField } from "../SelectInputField/SelectInputField";

interface RoleSelectionFieldProps {
  value: Role[];
  onChange: (value: Role[]) => void;
  disabled?: boolean | undefined;
  menuPortalTarget?: "popup" | undefined;
}

export const RoleSelectionField = (props: RoleSelectionFieldProps) => {
  const { settings } = useAPISettings();
  return (
    <SelectInputField
      multi={true}
      disabled={props.disabled}
      menuPortalTarget={props.menuPortalTarget}
      options={Role.ALL_ROLES.map((r) => new SelectInputData(r.id + "", getSingularRoleTitle(r.id, settings?.data)))}
      onChange={(value) => {
        if (Array.isArray(value)) {
          props.onChange(value.map((v) => Role.getRoleWithId(parseInt(v.value))));
        }
      }}
      selectedOptions={props.value.map((r) => new SelectInputData(r.id + "", getSingularRoleTitle(r.id, settings?.data)))}
    />
  );
};

